import {
  CLEAR_REDIRECT,
  CTA_SUBMIT,
  SET_BREADCRUMB,
  SET_ENGAGEMENT_DETAIL_ID,
  SET_FILTERED_ENGAGEMENTS,
  SET_REPLY_GUID
} from '@actions/types'

const initialState = {
  breadcrumbs: [],
  detailId: null,
  engagements: [],
  filteredEngagements: [],
  replyGuid: null,
  shouldNavigate: false
}

const reducer = (state = initialState, action) => {
  const { payload, type } = action

  switch (type) {
  case CLEAR_REDIRECT:
    return {
      ...state,
      shouldNavigate: false
    }
  case CTA_SUBMIT:
    return {
      ...state,
      shouldNavigate: true
    }
  case SET_BREADCRUMB:
    return {
      ...state,
      breadcrumbs: payload
    }
  case SET_ENGAGEMENT_DETAIL_ID:
    return {
      ...state,
      detailId: payload
    }
  case SET_FILTERED_ENGAGEMENTS:
    return {
      ...state,
      filteredEngagements: payload
    }
  case SET_REPLY_GUID:
    return {
      ...state,
      replyGuid: payload
    }
  default:
    return state
  }
}

export default reducer
